export default __webpack_public_path__ + "static/media/flag_en.90070044.svg";